var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { AxiosStorage } from './storage';
export class MemoryAxiosStorage extends AxiosStorage {
    constructor(storage = {}) {
        super();
        this.storage = storage;
        this.find = (key) => __awaiter(this, void 0, void 0, function* () {
            return this.storage[key] || { state: 'empty' };
        });
        this.set = (key, value) => __awaiter(this, void 0, void 0, function* () {
            this.storage[key] = value;
        });
        this.remove = (key) => __awaiter(this, void 0, void 0, function* () {
            delete this.storage[key];
        });
    }
}
